import { render, staticRenderFns } from "./subjectDetail.vue?vue&type=template&id=fa9324b6&scoped=true"
import script from "./subjectDetail.vue?vue&type=script&lang=js"
export * from "./subjectDetail.vue?vue&type=script&lang=js"
import style0 from "./subjectDetail.vue?vue&type=style&index=0&id=fa9324b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9324b6",
  null
  
)

export default component.exports